import { Link } from "react-router-dom";
import TopNav from "@/components/feature/TopNav";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <TopNav />
      <main className="w-full bg-background-50">
        <div className="w-full px-4 md:px-8 py-20 md:py-28">
          <div className="mx-auto max-w-xl text-center">
            <span className="font-heading text-6xl md:text-8xl font-bold text-primary-200 select-none">404</span>
            <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              这个页面先下线了
            </h1>
            <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
              你访问的地址可能已经调整，或者这条爆料已经合并到其他话题里。回到首页，看看此刻全网正在聊什么。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/"
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-home-4-line" aria-hidden="true"></i>
                </span>
                返回首页
              </Link>
              <Link
                to="/topics"
                className="inline-flex items-center gap-2 rounded-md border border-background-400/70 bg-background-100 px-6 py-3 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览分类专题
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}